import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';

import { ToastrService } from 'ngx-toastr';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { DataService, CustomerService, SiteTypeService, DashboardService, VirtualTimeSeriesService } from '../../../api/services';
import { SearchSource } from '../../../api/models/search-source';
import { SearchItem } from '../../../api/models/search-item';
import { Dashboard } from '../../../api/models/dashboard';
import { Customer } from '../../../api/models/customer';
import { TransformDetail,SiteType, SiteTwin, VirtualTimeSeries, VirtualTimeSeriesRecord } from '../../../api/models';
import { DataAnalysisTimeSeries } from '../../../api/models/data-analysis-time-series';
import { DataAnalysisConfig, DataAnalysisItem, DataAnalysisTransform } from '../../models/data-analysis';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { OpenStreetMapComponent } from 'src/app/components/open-street-map/open-street-map.component';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { AlarmEditorComponent } from 'src/app/components/alarm-editor/alarm-editor.component';
import { DashboardComponent } from 'src/app/views/dashboard/dashboard.component';
import { DashboardSelection } from 'src/app/models/dashboard';

@Component({
  selector: 'app-site-type',
  templateUrl: './site-type.component.html',
  styleUrls: ['./site-type.component.css'],
  providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }]
})
export class SiteTypeComponent implements OnInit {
  @ViewChild('dashboardViewer', { read: DashboardComponent, static: true }) dashboard: DashboardComponent;
  @ViewChild('alarmEditor', { read: AlarmEditorComponent, static: true }) alarmEditor: AlarmEditorComponent;
  @ViewChild('streetMap', { read: OpenStreetMapComponent, static: true }) map: OpenStreetMapComponent;
  @ViewChild('tabs', { static: false }) tabs?: TabsetComponent;
 
  loading: boolean = false;
  title = "app";
    
  public errorMessage: string = "";
  public inputFilter: string;
  public pageSize: number = 100;
  public pageIndex: number = 0;
  public allTimeSeries: SiteTwin[];
  public results: SiteTwin[];
  public siteType: SiteType;
  public columns: string[] = [];
  public totalItems: number = 100;
  public maxPages: number = 4;
  public lastSearchTest: string;

  public virtualTimeSeries: VirtualTimeSeriesRecord[];
  public selectedVirtualTimeSeries: VirtualTimeSeriesRecord;

  selectedDashboardId: number;
  selectedSiteUri: string;

  sortableOptions: any;

  virtualSiteTypeId: number;
  siteTypeId: number;

  selectedColumn: string = "Site";
  sortOrder: string = "ascending";
  private searchTimeout: any;


  constructor(
    private decimalPipe: DecimalPipe,
    private dashboardService: DashboardService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private app: ApplicationConfigService,
    private customerService: CustomerService,
    private vtsService: VirtualTimeSeriesService,
    private siteTypeService: SiteTypeService,
    public azureAuthService: AzureAuthService,
    private toasterService: ToastrService,
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.dashboard.clear();
    this.route.params.subscribe(params => {
      this.siteTypeId = parseInt(params["siteTypeId"]);
      
      //todo: replace with look up by ID
      this.siteTypeService.SiteTypeGetById({customerId: this.app.customerId, siteTypeId: this.siteTypeId}).subscribe(d => {
        this.siteType = d;
        this.doSearch();
      });

      this.vtsService.VirtualTimeSeriesGetVirtualSeries({customerId:this.app.customerId, siteTypeId: this.siteTypeId})
        .subscribe(r => {
          this.virtualTimeSeries = r;
          console.log(r);
        });
      
      this.results = [];
      this.columns = [];
      this.allTimeSeries = [];

      // monitor lists for changes
      this.sortableOptions = {
        animation: 150,
        onUpdate: (event: any) => {
            
        }
      };
    });
  }

  selectSite(site){
    debugger;
    this.selectedSiteUri = site.siteUri;
    this.selectedDashboardId = this.siteType.dashboards[0].dashboardId;
    this.dashboard?.reload({dashboardId:this.selectedDashboardId, siteUri:this.selectedSiteUri} as DashboardSelection);
  }

  openSite(site){
    
  }

  addVirtual(){
    this.selectedVirtualTimeSeries = { siteTypeId: this.siteType.siteTypeId, customerId: this.app.customerId, config: { transforms:[] } } as VirtualTimeSeriesRecord;
  }

  editVirtual(vts){
    this.selectedVirtualTimeSeries = vts;
  }

  //debounce on searching
  onInput(event: Event): void {   
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.doSearch();
    }, 250); // 250ms debounce time
  }

  

  public doSearch() {
    this.dashboard.clear();
    this.selectedDashboardId = 0;
    this.selectedSiteUri = null;
    if (this.inputFilter == null){
      this.inputFilter = "";
      this.lastSearchTest = this.inputFilter;
    }
    if (this.loading){
      // don't try another search if one is active
      return;
    }
    this.loading = true;
    this.allTimeSeries = [];
    this.map?.clearSearchResults();

    if(this.lastSearchTest != this.inputFilter)
    {
      this.pageIndex = 1;
      this.cdr.detectChanges();
    }
    this.lastSearchTest = this.inputFilter;

    this.siteTypeService.SiteTypeSearch({ type:this.siteType.siteTypeCode, customerId: this.siteType.customerId, search: this.inputFilter, searchSize: this.pageSize, pageIndex: this.pageIndex, filterOld: false, sortColumn:this.selectedColumn,sortOrder:this.sortOrder}).subscribe(r => {
      console.log("Searh Results", r);
      this.loading = false;
      this.errorMessage = "";
      this.results = r;
      var all = [];
      var sites = [];
      if (r){
        for (let twin of r){
          for (let key in twin.parameters){
            var item = twin.parameters[key];
            if (item.name.toLowerCase() != "message" && !this.columns.includes(item.name) && !item.hidden){
              this.columns.push(item.name)
            }
          }
        }
      }
      this.mapTabSelected();
      this.map?.showSearchResult(sites, 
        // onload
        (marker, item) => {
          
        },
        // onselect
        (marker, item) => {
         
        }, true);
      this.allTimeSeries = all;
      //pagination server-side
      if (r.length >= this.pageSize) {
        this.totalItems = Math.max(((this.pageIndex - 1) * this.pageSize) + this.pageSize + 1, 100);
        this.maxPages = 4;
        this.cdr.markForCheck();
      }
      else {
        this.totalItems = ((this.pageIndex - 1) * this.pageSize) + r.length;
        if (this.pageIndex < 4) {
          this.maxPages = this.pageIndex;
        }
        this.cdr.markForCheck();
      }
      this.cdr.detectChanges();

    }, error => {
      this.loading = false;
      console.log(error);
      this.errorMessage = " :  " + error.error;
    });
  }

  getValue(item: SiteTwin, column: string){
    for (let key in item.parameters){
      var val = item.parameters[key];
      if (val.name == column){
        var latest = val.latestValue;
        if (latest === null){
          return "";
        }
        if(latest.type != "String")
        {
          try {
            return this.decimalPipe.transform((latest as any).value, '1.0-2');
          }
          catch {
            return "-";
          }
        }
        else if (latest.type == "String" && latest.value.length <10){
          return latest.value.toString();
        }
        else{
          return "-";
        }

      }
    }
    return "-";
  }

  getUnits(item: SiteTwin, column: string){
    for (let key in item.parameters){
      var val = item.parameters[key];
      if (val.name == column){
        return val.units;
      }
    }
    return "";
  }

  getTime(item){
    return item.latestTime;
    //return item.age;
    //return "recent";
  }

  public openAlarmEditor(ts){
    this.alarmEditor.openModal(ts.uri);
  }

  //sortColumn: string;
  //sortDirection: boolean;

  columnSortStyle(column: string){
      if (column == this.selectedColumn && this.sortOrder == "descending"){
          return "fa fa-sort-desc";
      }
      
      if (column == this.selectedColumn && this.sortOrder == "ascending"){
          return "fa fa-sort-asc";
      }
      return "fa fa-sort";
  }

  columnSort(column: string) {
    //this.selectedColumn = column;
    //this.sortDirection = !this.sortDirection;
    if (this.selectedColumn == column) {
      if (this.sortOrder == "ascending") {
        this.sortOrder = "descending";
      }
      else {
        this.sortOrder = "ascending";
      }
    }
    else {
      this.sortOrder = "ascending";
    }


    this.selectedColumn = column;
    console.log("sort column",this.selectedColumn,this.sortOrder)

    //console.log("SORT:" + this.sortColumn + " " + this.sortDirection);
    this.doSearch();
  }

  setPageSize(index){
    this.pageSize = index;
    this.doSearch();
  }

  pageChange(event){
    console.log(event);
    //this.pageSize = event.itemsPerPage;
    this.pageIndex = event.page;
    this.doSearch();
  }

  loadMap(ts: DataAnalysisItem, tsv: DataAnalysisTimeSeries) {
    for (let v of tsv.values) {
      this.map?.loadGeoJson(ts.uri, v.valueStr, ts.colour);
    }
  }

  mapTabSelected(){
    this.map?.redraw();
  }
}
